import React from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { img_check } from '../../../utils/ImagesManagementUtils';

//= ========================================================================
const CheckBoxButton = ({
  onValueChanged,
  isChecked,
  title,
  isDisabled = false,
}) => {
  const myStyles = {
    container: {
      flexDirection: 'row',
      flexBasis: '40%',
      textAlign: 'center',
    },
    checkBox: {
      width: 20,
      height: 20,
      marginEnd: 8,
      borderRadius: 5,
      backgroundColor: isChecked ? '#008cff' : '#f1f5f9',
      border: 'solid 2px #008cff',
      opacity: isDisabled ? 0.5 : 1.0,
    },
    checkImage: {
      width: '100%',
      height: '100%',
    },
    text: {
      wordWrap: 'break-word',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  };
  return (
    <TouchableOpacity
      style={myStyles.container}
      disabled={isDisabled}
      onPress={() => {
        onValueChanged(!isChecked);
      }}
    >
      <View style={myStyles.checkBox}>
        {isChecked && (
          <Image
            fadeDuration={0}
            style={myStyles.checkImage}
            source={img_check}
          />
        )}
      </View>
      <Text style={myStyles.text}>
        {title}
      </Text>
    </TouchableOpacity>
  );
};

export default CheckBoxButton;
